import React from 'react'
import PageHeader from '../../pageheader/PageHeader'
import MenuDoctor from '../navDoctor/MenuDoctor'
import styles from './TableDataAccess.module.css'
import { MagnifyingGlassPlusIcon } from '@heroicons/react/24/outline'
import Pagination from './../../pagination/Pagination'

function DataAccess() {
    const dataMockup = [
        {
            pid: "1",
            fname: "สุขใจ",
            lname: "มีความสุข",
            title: "Lodasdasdsadsadassssssssssssssssssssssssssssssssssss"
        },
        {
            pid: "2",
            fname: "สุขใจ",
            lname: "มีความสุข",

            title: "Lodasdasdsadsadassssssssssssssssssssssssssssssssssss"
        },
        {
            pid: "3",
            fname: "สุขใจ",
            lname: "มีความสุข",
            title: "Lodasdasdsadsadassssssssssssssssssssssssssssssssssss"
        },
        {
            pid: "4",
            fname: "สุขใจ",
            lname: "มีความสุข",
            title: "Lodasdasdsadsadassssssssssssssssssssssssssssssssssss"
        },
        {
            pid: "5",
            fname: "สุขใจ",
            lname: "มีความสุข",
            title: "นางสาวสุขใจ มีความสุข"
        },
        {
            pid: "6",
            fname: "สุขใจ",
            lname: "มีความสุข",
            title: "Lodasdasdsadsadassssssssssssssssssssssssssssssssssss"
        }
    ]
    return (
        <div className='global-page'>
            <MenuDoctor />
            <PageHeader titlename={'สิทธิการเข้าถึงข้อมูล'} btnBackWard backpath={'/searchDataPatient'} description={'รายชื่อประชาชนที่สามารถเข้าถึงข้อมูลการตรวจแลป'} />
            <div className='ml-24 mr-24 mb-12'>
                <div className='flex items-center gap-3'>
                    <div className='text-xl'>
                        รายชื่อประชาชนที่ได้รับอนุญาตเข้าถึงข้อมูล
                    </div>
                </div>
                <div className='text-[#91A5AC] mt-2 mb-2'>{`จำนวน ${6} คน`}</div>

                <div className={styles.align}>
                    <div className={styles.scrollbar}>
                        <table className={styles.tg}>
                            <tr>
                                <th>ลำดับที่</th>
                                <th>ชื่อ</th>
                                <th>นามสกุล</th>
                                <th>วันเวลาที่ขออนุญาตครั้งแรก</th>
                                <th>ดูข้อมูล</th>
                            </tr>
                            <tbody>
                                {dataMockup.map((i, idx) => (
                                    <tr key={idx}>
                                        <td className='text-[#526F65]'>{i["pid"]}</td>
                                        <td className='text-[#526F65]'>{i["fname"]}</td>
                                        <td className='text-[#526F65]'>{i["lname"]}</td>
                                        <td>9:40 20 ม.ค 66</td>
                                        <td>
                                            <div className='flex justify-center'>
                                                <MagnifyingGlassPlusIcon className='w-6 stroke-[#07842f] hover:cursor-pointer' />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <Pagination page={1} totalpage={12} />
            </div>
        </div>
    )
}

export default DataAccess